import { useMutation } from "@apollo/client";
import { PREPARE_CARD_CHECKOUT_PAYMENT } from "../orderTypeDefs";

export const useMutationPrepareCardCheckoutPayment = (options?: any): any =>
  useMutation(PREPARE_CARD_CHECKOUT_PAYMENT, options);
